var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnadir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1918 8.5018H18.1506V7.47486C18.1506 7.03463 17.7885 6.67761 17.3423 6.67761C16.8961 6.67761 16.5341 7.03463 16.5341 7.47486V8.5018H15.4928C15.0462 8.5018 14.6846 8.85882 14.6846 9.29905C14.6846 9.73929 15.0466 10.0963 15.4928 10.0963H16.5341V11.1232C16.5341 11.5635 16.8961 11.9205 17.3423 11.9205C17.7885 11.9205 18.1506 11.5635 18.1506 11.1232V10.0963H19.1918C19.6385 10.0963 20.0001 9.73929 20.0001 9.29905C20.0001 8.85882 19.638 8.5018 19.1918 8.5018Z",
    fill: "#223D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3491 19.2372C11.4367 20.0428 7.25089 20.446 2.99315 19.2372C1.3348 18.7666 0 17.7197 0 16.2171C0 14.7009 1.38175 13.7451 3.03544 13.1921C6.44857 12.0499 10.2508 11.9122 14.3068 13.1921C15.9702 13.7168 17.3422 14.7009 17.3422 16.2171C17.3422 17.7197 16.0117 18.7774 14.3491 19.2372Z",
    fill: "#223D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6711 10.9834C11.746 10.9834 14.2387 8.52469 14.2387 5.4917C14.2387 2.45872 11.746 0 8.6711 0C5.59621 0 3.10352 2.45872 3.10352 5.4917C3.10352 8.52469 5.59621 10.9834 8.6711 10.9834Z",
    fill: "#223D51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnadir);
export default __webpack_public_path__ + "static/media/anadir.c6e1616751d13f2188f97f0c2c9f6b9b.svg";
export { ForwardRef as ReactComponent };